import React from 'react'
import ReactDOM from 'react-dom'
import Styles from './styles.module.sass'

function Loading(props){
    const {classLoading} = props
    return(
        <div className={`${Styles?.modal} ${Styles?.loading} ${classLoading}`}>
            <div className={Styles?.contentModal}>               
                <div className={Styles?.spinner}></div>
            </div>
        </div>
    )
}

export default function ModalLoading (props){
    const {type} = props
    return ReactDOM.createPortal(
        <Loading classLoading={type} />,
        document.getElementById('modal-root')
    )
}